module.exports = __webpack_public_path__ + "static/media/appdesign.cff1625b.svg";